export const BASE_URL = 'https://shop-wave.onrender.com'
export const PRODUCTS_URL = '/api/products'
export const USERS_URL = '/api/users'
export const ORDERS_URL = '/api/orders'
export const PAYPAL_URL = '/api/paypal'
export const UPLOAD_URL = '/api/upload'
